import { Link } from 'react-router-dom';
import styled from 'styled-components';

const UndecoratedLink = styled(Link)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export default UndecoratedLink;